<script lang="ts">
    import {
        AddressBookSolid,
        ClipboardSolid, CloseCircleSolid, CogSolid, EditSolid, FilePenSolid, FolderDuplicateSolid,
        FolderSolid, GridSolid,
        MessagesSolid, PenOutline,
        TicketOutline, UsersGroupSolid,
        UserSolid
    } from "flowbite-svelte-icons";
import CustomerAvatar from "$lib/components/CustomerAvatar.svelte";
import {page} from "$app/stores";
    import {onMount, setContext} from "svelte";
import {allUnits} from "$lib/stores/unit";
import {getUnits} from "$lib/calls/unit";
import {writable} from "svelte/store";
    import TabButton from "$items/TabButton.svelte";
    import {Button} from "flowbite-svelte";

const super_edit = writable(false);

setContext('super_edit', super_edit);

let storedCustomer = null;

$: headquarter = $page.data.customer.parentId ? $page.data.customer.parent : $page.data.customer;

$: isHeadquarter = !$page.data.customer.parentId;

onMount(async () => {
    console.log({data: $page.data, isHeadquarter})
    if($allUnits.length === 0) {
        $allUnits = await getUnits();
    }
})

</script>

<div class="flex flex-col md:flex-row items-start gap-3 px-4 pt-7">
    <div class="flex flex-1 flex-row items-center gap-3">
        <CustomerAvatar bgColor="bg-primary-500" size="3xl" customer={headquarter}/>
        <div class="flex flex-col items-start gap-1">
            <h1 class="text-base text-neutral-600 sm:text-lg md:text-2xl font-bold">{$page.data.customer.name}</h1>
            {#if isHeadquarter}
                <span class="text-neutral-600">Hauptsitz</span>
            {:else}
                <span class="text-neutral-600">Unit: {$page.data.customer?.unit?.name}</span>
                <div class="text-neutral-600 text-[14px] flex gap-2"><TicketOutline class="text-primary-400 "/> <span>{$page.data.customer.registry || 'Lead'}</span></div>
            {/if}


        </div>
    </div>
    <div class="flex gap-3 mb-2">
        {#if $super_edit}
            <Button size="xs" class="bg-red-400" on:click={() => {$super_edit = false; $page.data.customer = storedCustomer}} >
                <CloseCircleSolid class="w-4 mr-2"/>
                Abbrechen
            </Button>
        {:else}
            <Button size="xs"  on:click={()=> {$super_edit = true; storedCustomer = {...$page.data.customer} }} icon={EditSolid}>
                <PenOutline class="w-4 mr-2"/>
                <span>Bearbeiten</span>
            </Button>
        {/if}

    </div>
</div>
<div class="flex flex-row items-end justify-between w-full md:border-b border-gray-300 mt-5">
    <div class="flex flex-wrap md:flex-nowrap flex-row justify-start items-center gap-3 md:gap-0">
        <TabButton href="/employee/{$page.params.uuid}" icon={AddressBookSolid}
                   title="Kundendaten"/>
        <TabButton href="/employee/{$page.params.uuid}/vertrag" icon={FilePenSolid}
                   title="Konditionen"/>
        <TabButton href="/employee/{$page.params.uuid}/vertrag" icon={GridSolid}
                   title="Projekte"/>
        <TabButton href="/employee/{$page.params.uuid}/dokumente" icon={FolderDuplicateSolid}
                   title="Dokumente"/>
        <TabButton href="/employee/{$page.params.uuid}/dokumente" icon={UsersGroupSolid}
                   title="Ansprechpartner"/>
        <TabButton href="/employee/{$page.params.uuid}/dokumente" icon={CogSolid}
                   title="Einstellungen"/>

    </div>
    <div class="flex gap-3 mb-2">actions</div>
</div>
<div class="pt-12 px-0">
    <slot/>
</div>